"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEditSpotOrder = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const interface_1 = require("../../../interface");
const FutureAPI_1 = require("../../../apis/FutureAPI");
const SpotTradeProcessor_1 = require("./SpotTradeProcessor");
const CheckSpotRequest_1 = require("./CheckSpotRequest");
/**
 * 编辑市价单，限价单对应的hooks
 */
function useEditSpotOrder({ order, curPrice, symbolInfo, leveragedCoinQuota, leveragedCoinAccountQuota, customBalanceObservable, }) {
    const { type, price, qty, side } = order;
    // 限价单对应的价格
    const [orderPrice, setOrderPrice] = (0, react_1.useState)(new trade_utils_lib_1.SafeDecimal(price).toFixed() || "");
    // 订单对应的下单量
    const [orderQty, setOrderQty] = (0, react_1.useState)(qty);
    const accountType = trade_utils_lib_1.AccountTradeType.bot;
    const investSide = interface_1.InvestSymbolSide.base;
    const { available, canBuy, volume, baseTotal } = (0, SpotTradeProcessor_1.useSpotTradeParams)({
        accountType,
        symbolInfo,
        orderType: type,
        orderSide: side,
        investSide,
        price: orderPrice,
        invest: orderQty,
        curPrice,
        isFocused: true,
        leveragedCoinQuota,
        leveragedCoinAccountQuota,
        customBalanceObservable,
    });
    const checkUserModify = (0, react_1.useCallback)(() => {
        return !new trade_utils_lib_1.SafeDecimal(orderQty).eq(new trade_utils_lib_1.SafeDecimal(qty)) || !new trade_utils_lib_1.SafeDecimal(orderPrice).eq(new trade_utils_lib_1.SafeDecimal(price));
    }, [orderPrice, orderQty, price, qty]);
    const modifyOrder = (0, react_1.useCallback)(() => {
        return (0, CheckSpotRequest_1.processSpotUIOrderRequest)({
            accountType,
            symbol: symbolInfo,
            orderType: type,
            side,
            investSide: investSide,
            available,
            /** 可投金额 需要加上当前订单的投资额 */
            canBuy: new trade_utils_lib_1.SafeDecimal(canBuy).add(new trade_utils_lib_1.SafeDecimal(qty)).toString(),
            price: orderPrice,
            curPrice,
            invest: orderQty,
            volume,
            baseTotal,
            leveragedCoinQuota: leveragedCoinQuota,
            leveragedCoinAccountQuota: leveragedCoinAccountQuota,
        }).pipe((0, operators_1.mergeMap)((req) => (0, FutureAPI_1.modifyCustomOrder)(Object.assign({ order_id: order.id }, req))), (0, operators_1.catchError)((error) => {
            return (0, rxjs_1.throwError)((0, trade_utils_lib_1.getTradeDependencyInstance)().localizeError(error));
        }));
    }, [
        accountType,
        available,
        baseTotal,
        canBuy,
        curPrice,
        investSide,
        leveragedCoinAccountQuota,
        leveragedCoinQuota,
        order.id,
        orderPrice,
        orderQty,
        qty,
        side,
        symbolInfo,
        type,
        volume,
    ]);
    return {
        setOrderPrice,
        setOrderQty,
        orderPrice,
        orderQty,
        checkUserModify,
        modifyOrder,
    };
}
exports.useEditSpotOrder = useEditSpotOrder;
